'use client';

import { storyblokEditable } from '@storyblok/react';
import clsx from 'clsx';
import { nanoid } from 'nanoid';

import { useState } from 'react';

import commonStyles from '../Common.module.scss';

import { Icon, Typography } from '@/components/core';
import { useOutsideClick } from '@/hooks/useClickOutside';
import { SelectFormStoryblok } from '@/types/storyblok/storyblok-types';

import styles from './SelectForm.module.scss';

type SelectFormProps = {
    blok: SelectFormStoryblok;
    props?: any;
    required?: boolean;
    error?: any | null;
    isTouched?: boolean;
};

export const SelectForm: React.FC<SelectFormProps> = ({ blok, props, required, error, isTouched }) => {
    const { label, placeholder, options, width } = blok;
    const [isOpen, setIsOpen] = useState(false);
    const ref = useOutsideClick(() => {
        setIsOpen(false);
    });
    return (
        <div
            ref={ref}
            {...storyblokEditable(blok)}
            className={clsx(commonStyles.root, {
                [commonStyles.halfWidth]: width === '50%',
                [styles.open]: isOpen,
            })}
        >
            <div>
                <label className={clsx(commonStyles.label, 'label')}>{label}</label>
                {required && <span className={commonStyles.asterix}>*</span>}
            </div>
            <div className={clsx(styles.wrapper)}>
                <div
                    onClick={() => setIsOpen(prev => !prev)}
                    className={clsx(commonStyles.input, styles.placeholder, { [styles.selected]: !!props.value })}
                >
                    {props.value ?? placeholder}
                    <Icon
                        className={styles.chevron}
                        name="rounded-chevron"
                    />
                </div>
                <div className={clsx(styles.dropdownOptions, { [styles.active]: isOpen })}>
                    {options.map(option => (
                        <div
                            key={nanoid()}
                            className={clsx(styles.option, styles.placeholder, commonStyles.input)}
                            onClick={() => {
                                props.onChange(option.content);
                                setIsOpen(false);
                            }}
                        >
                            {option.content}
                        </div>
                    ))}
                </div>
            </div>

            {error && isTouched && (
                <Typography
                    looksLike="pSmall"
                    className={styles.error}
                >
                    {error.message}
                </Typography>
            )}
        </div>
    );
};
